module.exports = __webpack_public_path__ + "img/btn3.732ff565.png";